import gql from 'graphql-tag';

const GET_BLACKLIST = gql`
    query getAllItems  {
        getAllItems {
            internalCode
            message
            payload {
                ean
                lastModifiedDate
                user
            }
        }
    }
`;

export default GET_BLACKLIST;
